export default
    {
        // 通过成人票查询婴儿儿童航班
        async searchBabyFlightByAdult(params) {
            let actiontype = 'FlightService_AdultDetrTNHandler';
            return await this.fetch(actiontype, params);
        },
        async searchBabyCabin(params) {
            let actiontype = 'searchFlights';
            return await this.fetch(actiontype, params);
        }
    }


// WEBPACK FOOTER //
// ./src/interfaces/modules/babytk.js